module.exports = __webpack_public_path__ + "img/04—01—01—Settings > Save Confirmation.a3e681eb.jpg";